import React from 'react';
import { countEventIssues } from 'modules/PixelTester/utils/utils';
import { COMMON_FLAGS, useCommonConfig } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { EventsContent } from './components/EventsContent/EventsContent';
import { EventsHeader } from './components/EventsHeader/EventsHeader';
import styles from './eventsWrapper.module.scss';

export const EventsWrapper = () => {
    const { value: pixelTesterEvents = [] } = useFormFieldValue({
        field: 'pixelTesterEvents',
    });

    const { [COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS]: defaultShopifyEvents } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS,
    ]);

    const issueCount = countEventIssues(pixelTesterEvents, defaultShopifyEvents);

    return (
        <div className={styles['container']}>
            <EventsHeader issueCount={issueCount} />
            <EventsContent />
        </div>
    );
};
